function isMounted(_this) {
  _this.$i18n.locale = sessionStorage.getItem("lang");
  if (typeof _this.pageData.username == undefined || _this.pageData.username == null || _this.pageData.username == '') {
    return false;
  }
  if (_this.pageData.custUserinfo.usertype != '1') {
    return false;
  }
  return true;
}

function isMountedManage(_this) {
  _this.$i18n.locale = sessionStorage.getItem("lang");
  if (typeof _this.pageData.username == undefined || _this.pageData.username == null || _this.pageData.username == '') {
    return false;
  }
  if (_this.pageData.Userinfo.usertype != '2') {
    return false;
  }
  return true;
}

function strIsEmpty(params) {
  if (typeof params === undefined || params === null || params === '' || params == undefined) {
    return true;
  }
  return false;
}


export {
  isMounted,
  isMountedManage,
  strIsEmpty
}



// WEBPACK FOOTER //
// ./src/assets/js/verify.js